import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import { replaceComponents } from '../lib/helpers';
import {DownloadModal} from '../components/download-modal';
import {ChannelAddModal} from '../components/channel-add-modal';
import {LicenseModal} from '../components/license-modal';
import {Tooltip} from '../components/tooltip';
import {VideoAttributionModal} from '../components/video-attribution-modal';
import {OnboardingBetaModal} from '../components/onboarding-beta-modal';
import {OnboardingSignUpModal} from '../components/onboarding-sign-up-modal';
import {OnboardingModal} from '../components/onboarding-modal';
import {OnboardingTermsConditionsModal} from '../components/onboarding-terms-conditions-modal';
import {OnboardingPrivacyPolicyModal} from '../components/onboarding-privacy-policy-modal';
import {OnboardingSpotifyModal} from '../components/onboarding-spotify-modal';
import {OnboardingTwitterModal} from '../components/onboarding-twitter-modal';
import {ChannelSelectModal} from '../components/channel-select-modal';
import {DeleteAccountModal} from '../components/delete-account-modal';
import {DownloadAccountDataModal} from '../components/download-account-data-modal';
import {noop} from '../lib/noop';
import {RestrictedModal} from "../components/restricted-modal";
import {BasketRestrictedModal} from "../components/basket-restricted-modal";

export interface ModalsProps {}

@inject(deps) @observer
export class Modals extends Component<ModalsProps> {
  render() {
    const uiController = this.props.controller.ui;
    const onboardingModel = this.props.model.onboarding;
    const onboardingController = this.props.controller.onboarding;
    const content = this.props.model.content;

    const modalModel = this.props.model.modal;
    const modalController = this.props.controller.modal;

    const downloadI18n = {
      ...DownloadModal.i18n,
      title: content.downloadModalTitle,
      strap: content.downloadModalStrap,
      agree: content.downloadModalAgree
    };

    const addChannelI18n = {
      ...ChannelAddModal.i18n,
      strap: content.addChannelStrap
    };

    // TODO remove this after prod deploy
    const licenceStrap = `If your video is being sponsored by a brand, you'll need a {{brand_sponsored}} license.`;
    const licenceTooltipContent = `This song is available for use in Brand Sponsored content, from just $80. This means if you're being paid to make a promotional video on-behalf of a brand you can license this song legally for use in your video.`;
    
    const licenseModalI18n = {
      ...LicenseModal.i18n,
      title: content.licenceModalTitle,
      loading: content.licenceModalLoading,
      // strap: content.licenceModalStrap,
      strap: replaceComponents(licenceStrap, {
        brand_sponsored: (
          <Tooltip content={licenceTooltipContent}>Brand Sponsored</Tooltip>
        )
      }),
      not_available: content.licenceModalNotAvailable,
      close: content.licenceModalClose,
    };

    const attributionModalI18n = {
      ...VideoAttributionModal.i18n,
      why: content.attributionWhy,
      strap: content.attributionBlurb
    };

    return (
      <span>
        <OnboardingBetaModal
          model={onboardingModel.betaModal}
          onRequestClose={onboardingController.dismissBetaModal}
          onChangeEmail={onboardingController.changeBetaEmail}
        />
        <OnboardingSignUpModal
          model={onboardingModel.signUpModal}
          onClickSignUp={uiController.openSignInWindow}
          onRequestClose={onboardingController.closeSignUpModal}
          onClickTermsConditions={this.handleClickTermsConditions}
          onClickPrivacyPolicy={this.handleClickPrivacyPolicy}
          i18n={content.signUpModalI18n}
        />
        <OnboardingModal
          model={onboardingModel.detailsModal}
          onRequestClose={onboardingController.closeDetailsModal}
          onSubmit={onboardingController.submitDetailsModal}
          onClickLink={this.handleClickTermsConditions}
        />
        <OnboardingTermsConditionsModal
          model={onboardingModel.termsConditionsModal}
          onRequestClose={onboardingController.closeTermsConditionsModal}
        />
        <OnboardingPrivacyPolicyModal
          model={onboardingModel.privacyPolicyModal}
          onRequestClose={onboardingController.closePrivacyPolicyModal}
        />
        <OnboardingSpotifyModal
          model={onboardingModel.spotifyModal}
          onRequestClose={onboardingController.closeSpotifyModal}
          onSkip={onboardingController.skipSpotifyModal}
        />
        <OnboardingTwitterModal
          model={onboardingModel.twitterModal}
          onRequestClose={onboardingController.closeTwitterModal}
          onSkip={onboardingController.skipTwitterModal}
          onFollowUs={onboardingController.setTwitterFollow}
        />
        <DownloadModal
          model={modalModel.downloadModal}
          i18n={downloadI18n}
          onAgreeToTerms={modalController.agreeToDownloadTerms}
          onRequestClose={modalController.hideDownloadModal}
          onDownloadOriginal={this.acknowledgeTrackDownload}
          onDownloadInstrumental={noop}
          onDownloadVocal={noop}
          onSendAllToDropbox={noop}
        />
        <VideoAttributionModal
          i18n={attributionModalI18n}
          model={modalModel.attributionModal}
          onRequestClose={modalController.hideAttributionModal}
        />
        <ChannelAddModal
          i18n={addChannelI18n}
          model={modalModel.addChannel}
          onSearch={modalController.addChannelSearch}
          onSelect={modalController.addChannelSelect}
          onDeselect={modalController.addChannelDeselect}
          onLink={modalController.addChannelLink}
          onRequestClose={modalController.hideChannelAddModal}
        />
        <ChannelSelectModal
          model={modalModel.selectChannel}
          onRequestClose={modalController.hideChannelSelectModal}
          onSelectChannel={modalController.changeChannel}
          onAdd={modalController.showChannelAddModal}
        />
        <LicenseModal
          i18n={licenseModalI18n}
          model={modalModel.license}
          onRequestClose={modalController.hideLicenseModal}
          onSelectRate={modalController.licenseModalSelectRate}
        />
        <RestrictedModal
            model={modalModel.restricted}
            onRequestClose={modalController.hideRestrictedModal}
        />
        <BasketRestrictedModal
            basket={modalModel.basketRestricted}
            onRequestClose={modalController.hideBasketRestrictedModal}
        />
        <DeleteAccountModal
          model={modalModel.deleteAccount}
          onRequestClose={modalController.hideDeleteAccountModal}
          onDeleteAccount={modalController.submitDeleteAccount}
        />
        <DownloadAccountDataModal
          model={modalModel.downloadAccountData}
          onRequestClose={modalController.hideDownloadAccountDataModal}
          onDownload={modalController.submitDownloadAccountData}
        />
      </span>
    )
  }

  handleClickTermsConditions = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.controller.onboarding.showTermsConditionsModal();
  };

  handleClickPrivacyPolicy = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.controller.onboarding.showPrivacyPolicyModal();
  };

  handleReAuthSignIn = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.controller.modal.hideMustReAuthModal();
    this.props.controller.onboarding.openSignUpModal();
  }

  acknowledgeTrackDownload = (identity) => {
      return this.props.controller.api.audio.acknowledgeDownload(identity) as Promise<any>;
  }
}